/* ============================================================
   Parts Schematic v4 — data-driven drawing + legend
   Upload to: Shopify Admin → Themes → Edit code → Assets

   The section renders:
     #ezp-schem-data   JSON: {handle, hotspots, legend, sheets:[{src}], labels}
     #ezp-schem-stage  where the <svg> per sheet is built
     #ezp-schem-list   the legend rows (Liquid-rendered, enhanced here)
   Nothing about a specific drawing lives in this file.

   Geometry: hotspots are normalised 0..1 of each sheet's natural size
   (r of its width). One <svg> per sheet whose viewBox IS the current view:
   the drawing's content box at "fit", smaller when zoomed. Pan and zoom
   only ever rewrite that viewBox.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('ezp-schem');
  var dataEl = document.getElementById('ezp-schem-data');
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('Parts Schematic v4: bad data', e); return; }
  var hot = DATA.hotspots || {};
  var spots = Array.isArray(hot.spots) ? hot.spots : [];
  // outlines traced round a picture of a part that has no number on it (the
  // skimmer basket photo on Horizon 50-150-W011): {legend, sheet, pts:[[x,y],…]}
  var areas = Array.isArray(hot.areas) ? hot.areas : [];
  var legendRows = Array.isArray(DATA.legend) ? DATA.legend : [];
  var sheetDefs = Array.isArray(DATA.sheets) ? DATA.sheets : [];
  var L = DATA.labels || {};

  var stage = document.getElementById('ezp-schem-stage');
  var list = document.getElementById('ezp-schem-list');
  var drawer = document.getElementById('ezp-schem-drawer');
  var isTouch = window.matchMedia('(pointer: coarse)').matches;
  var narrow = function () { return window.matchMedia('(max-width: 1023px)').matches; };

  var normLegend = function (s) { return String(s == null ? '' : s).trim().toLowerCase().replace(/_+$/, ''); };

  /* ── the side list in CALLOUT order (Nate, 2026-09-29): "Not Shown" first
     (for now), then 1, 2, 3, 3A, 10 … counting up, whatever order the
     metafield came in — the hub wrote some pages in the distributor's list
     order, 36 down to 1. Same rule as the hub's legendCompare (schematics/
     common.js); rows with the same callout keep their order. ─────────── */
  (function sortList() {
    if (!list) return;
    var notShown = function (s) { return /^not\s*shown$/i.test(String(s || '').trim()); };
    Array.prototype.slice.call(list.querySelectorAll('.ezp-part'))
      .map(function (li, i) { return { li: li, k: String(li.dataset.legend || '').trim(), i: i }; })
      .sort(function (a, b) {
        var na = notShown(a.k), nb = notShown(b.k);
        if (na !== nb) return na ? -1 : 1;
        return a.k.localeCompare(b.k, undefined, { numeric: true, sensitivity: 'base' }) || a.i - b.i;
      })
      .forEach(function (r) { list.appendChild(r.li); });
  })();

  /* ── SECTIONS (2026-10-17): a drawing of several pages (the Dolphin E30's
     power supply, filter, motor, drive, body, brushes, cable …) groups the
     side list by page, under the page's name from the hub (else "Sheet N").
     A number's section is the page its first circle is on; numbers with no
     circle anywhere go last, under "Not on the drawing". A heading click
     brings that page up. Only when there is more than one page. ────────── */
  var sectionHeads = [];
  (function groupSections() {
    var sheetMeta = (hot && Array.isArray(hot.sheets)) ? hot.sheets : [];
    if (!list || sheetDefs.length < 2) return;
    var pageOf = {};
    spots.concat(areas).forEach(function (s) {
      var k = normLegend(s.legend), p = Number(s.sheet || 0);
      if (pageOf[k] == null || p < pageOf[k]) pageOf[k] = p;
    });
    // pages with the SAME name are one section in the list ("Filter Basket"
    // overview + exploded view): one heading, the first page's tab
    var nameOf = function (i) { return (sheetMeta[i] && sheetMeta[i].name) || ''; };
    var groupOf = function (i) {
      var n = nameOf(i).trim().toLowerCase();
      if (!n) return String(i);
      for (var j = 0; j < i; j++) if (nameOf(j).trim().toLowerCase() === n) return String(j);
      return String(i);
    };
    var groups = {};
    Array.prototype.slice.call(list.querySelectorAll('.ezp-part')).forEach(function (li) {
      var p = pageOf[normLegend(li.dataset.legend)];
      var g = p == null ? 'none' : groupOf(p);
      (groups[g] = groups[g] || []).push(li);
    });
    var order = sheetDefs.map(function (_, i) { return String(i); }).concat(['none']);
    order.forEach(function (g) {
      if (!groups[g]) return;
      var head = document.createElement('li');
      head.className = 'ezp-sect';
      head.setAttribute('role', 'presentation');
      if (g === 'none') {
        head.textContent = L.notOnDrawing || 'Not on the drawing';
      } else {
        var i = Number(g);
        head.dataset.sheet = i;
        // every page this heading covers, for marking it current
        head.dataset.sheets = sheetDefs.map(function (_, j) { return j; })
          .filter(function (j) { return groupOf(j) === g; }).join(',');
        head.textContent = nameOf(i) || ((L.sheet || 'Sheet') + ' ' + (i + 1));
        head.title = L.showPage || 'Show this page of the drawing';
      }
      list.appendChild(head);
      groups[g].forEach(function (li) { list.appendChild(li); });
      sectionHeads.push({ el: head, rows: groups[g] });
    });
    list.classList.add('has-sections');
  })();
  /** A heading with nothing visible under it (searched away, or every part
   *  not on the site) is hidden too. */
  function paintSections() {
    sectionHeads.forEach(function (s) {
      s.el.hidden = !s.rows.some(function (li) {
        return !li.hidden && !li.classList.contains('is-uncarried') && !li.classList.contains('is-unlisted');
      });
    });
  }

  // legend -> rows, legend -> circles (across sheets)
  var rowsByLegend = {};
  legendRows.forEach(function (r) {
    var k = normLegend(r.legend);
    (rowsByLegend[k] = rowsByLegend[k] || []).push(r);
  });
  var circlesByLegend = {};

  /* ── STEPPED CALLOUTS (2026-10-21, Nate) ─────────────────────────────
     A drawing prints ONE "7" where the legend has 7a, 7b, 7c, 7d: versions
     (Hayward Star-Clear: the C250's cartridge … the C1000's), each with its
     own brand options. The hub stacks their circles on the printed number.
     Such a family opens as ONE card, Legend #7, with a first row of chips —
     one per sub-number, labelled by the hub (schem_json `variant`, e.g.
     "C250 · 25 sq ft") — and the brand chips under it. The rule is the
     hub's (schematics/option-labels-plan.js variantGroups): sub-numbers of
     one base whose circles sit on the same spot of the same page. Printed
     apart (41a here, 41b there), they stay separate callouts. */
  var natural = function (a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }); };
  var familyOf = {};       // sub-number -> { base, keys }
  var familyByBase = {};   // "7" -> its family (a #part-7 link)
  var familyPick = {};     // base -> the sub-number last shown
  (function findFamilies() {
    var SUB = /^(\d+)([a-z]+)$/;
    var at = {};
    spots.forEach(function (s) {
      var k = normLegend(s.legend);
      if (!SUB.test(k) || !rowsByLegend[k]) return;
      var p = (Number(s.sheet) || 0) + ':' + Number(s.x).toFixed(4) + ':' + Number(s.y).toFixed(4);
      at[p] = at[p] || [];
      if (at[p].indexOf(k) === -1) at[p].push(k);
    });
    Object.keys(at).forEach(function (p) {
      var ks = at[p].filter(function (k) { return !familyOf[k]; }).sort(natural);
      if (ks.length < 2) return;
      var base = SUB.exec(ks[0])[1];
      if (ks.some(function (k) { return SUB.exec(k)[1] !== base; })) return;
      var fam = { base: base, keys: ks };
      ks.forEach(function (k) { familyOf[k] = fam; });
      if (!rowsByLegend[base]) familyByBase[base] = fam;
    });
  })();
  /** The sub-number a family opens on: the one last shown, else the first. */
  function familyEntry(k) {
    var fam = familyOf[k];
    return fam ? (familyPick[fam.base] || fam.keys[0]) : k;
  }

  /* Which callouts have nothing on the site. Filled once the products land;
     painted again whenever a sheet finishes building, because the drawing and
     products.json race and either can win. */
  var unlistedLegends = null;
  function paintUnlisted() {
    if (!unlistedLegends) return;
    Object.keys(unlistedLegends).forEach(function (k) {
      if (!unlistedLegends[k]) return;
      (circlesByLegend[k] || []).forEach(function (c) { c.el.classList.add('is-unlisted'); });
    });
  }

  /* ── sheets: one svg each ───────────────────────────────────────────── */
  var sheets = [];           // {i, el (svg), img, W, H, box:{x,y,w,h} px, view:{x,y,w,h}}
  var active = 0;

  function buildSheet(i, def, hotSheet) {
    var wrap = document.createElement('div');
    wrap.className = 'ezp-schem__sheet' + (i === 0 ? ' is-active' : '');
    wrap.dataset.sheet = i;
    stage.insertBefore(wrap, stage.querySelector('.ezp-schem__controls'));

    var img = new Image();
    img.decoding = 'async';
    img.onload = function () {
      var W = img.naturalWidth, H = img.naturalHeight;
      var nb = hotSheet && hotSheet.box;
      var box = nb ? { x: nb.x * W, y: nb.y * H, w: nb.w * W, h: nb.h * H } : { x: 0, y: 0, w: W, h: H };
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'ezp-schem__svg');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      var im = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      im.setAttribute('href', def.src);
      im.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', def.src);
      im.setAttribute('x', 0); im.setAttribute('y', 0);
      im.setAttribute('width', W); im.setAttribute('height', H);
      svg.appendChild(im);
      var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('class', 'ezp-schem__spots');
      // outlines go in first, so a circle that sits inside one stays on top.
      // The polygon is its own hit area; it is invisible until its row is
      // hovered or picked (css .ezp-spot--area).
      areas.filter(function (a) { return (a.sheet || 0) === i && Array.isArray(a.pts) && a.pts.length >= 3; }).forEach(function (a) {
        var k = normLegend(a.legend);
        var xs = a.pts.map(function (p) { return p[0] * W; });
        var ys = a.pts.map(function (p) { return p[1] * H; });
        var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
        poly.setAttribute('points', a.pts.map(function (p) { return (p[0] * W).toFixed(1) + ',' + (p[1] * H).toFixed(1); }).join(' '));
        poly.setAttribute('class', 'ezp-spot ezp-spot--area');
        poly.dataset.legend = k;
        var title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        var first = (rowsByLegend[k] || [])[0];
        title.textContent = String(a.legend) + (first ? ' — ' + first.description : '');
        poly.appendChild(title);
        g.appendChild(poly);
        var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs);
        var y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
        (circlesByLegend[k] = circlesByLegend[k] || []).push({
          el: poly, hit: poly, sheet: i, x: (x0 + x1) / 2, y: (y0 + y1) / 2, r: Math.max(x1 - x0, y1 - y0) / 2,
        });
      });
      spots.filter(function (s) { return (s.sheet || 0) === i; }).forEach(function (s) {
        var k = normLegend(s.legend);
        var r = Math.max(s.r * W, W * 0.008);
        var hit = circle(s.x * W, s.y * H, Math.max(r * 1.7, W * 0.02), 'ezp-spot__hit');
        var ring = circle(s.x * W, s.y * H, r, 'ezp-spot');
        ring.dataset.legend = k; hit.dataset.legend = k;
        var title = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        var first = (rowsByLegend[k] || [])[0];
        title.textContent = String(s.legend) + (first ? ' — ' + first.description : '');
        ring.appendChild(title);
        g.appendChild(hit); g.appendChild(ring);
        (circlesByLegend[k] = circlesByLegend[k] || []).push({ el: ring, hit: hit, sheet: i, x: s.x * W, y: s.y * H, r: r });
      });
      svg.appendChild(g);
      // captions (2026-10-17, hub migration 085): a typed name drawn beside an
      // outline or circle — "3-Wire Cable" on the E30's cable — that opens
      // the part like the circle does. Sized for ~12px on the stage as first
      // shown; it grows with zoom like the drawing.
      var caps = spots.concat(areas).filter(function (s) { return (s.sheet || 0) === i && s.caption; });
      if (caps.length) {
        var cg = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        cg.setAttribute('class', 'ezp-schem__caps');
        var stageW = stage.clientWidth || 360;
        var fs = Math.max(box.w * 0.008, 12.5 * box.w / stageW);
        caps.forEach(function (s) {
          var k = normLegend(s.legend);
          var text = String(s.caption);
          var b = captionBox(s, W, H, fs, box);
          var x = b.x, y = b.y, tw = b.w, th = b.h;
          var lab = document.createElementNS('http://www.w3.org/2000/svg', 'g');
          lab.setAttribute('class', 'ezp-cap');
          lab.dataset.legend = k;
          // dragged off the part on the hub: a leader line to it, like the
          // vendor's own callouts (2026-10-17, hub migration 086)
          if (b.line) {
            var ln = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            ln.setAttribute('x1', b.line[0]); ln.setAttribute('y1', b.line[1]);
            ln.setAttribute('x2', b.line[2]); ln.setAttribute('y2', b.line[3]);
            lab.appendChild(ln);
          }
          var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          rect.setAttribute('x', x); rect.setAttribute('y', y);
          rect.setAttribute('width', tw); rect.setAttribute('height', th);
          rect.setAttribute('rx', th / 2);
          var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          t.setAttribute('x', x + tw / 2); t.setAttribute('y', y + th / 2);
          t.setAttribute('font-size', fs);
          t.setAttribute('text-anchor', 'middle'); t.setAttribute('dominant-baseline', 'central');
          t.textContent = text;
          lab.appendChild(rect); lab.appendChild(t);
          cg.appendChild(lab);
          (circlesByLegend[k] = circlesByLegend[k] || []).push({ el: lab, hit: lab, sheet: i, caption: true,
            x: x + tw / 2, y: y + th / 2, r: tw / 2 });
        });
        svg.appendChild(cg);
      }
      // the crop is a clip as well as the fit: a tall crop letterboxes in a
      // wide stage, and panning may overhang it — neither may show what the
      // crop cut off (hub ✂ crop, 2026-10-08)
      if (nb) {
        var cid = 'ezp-crop-' + Math.random().toString(36).slice(2, 8);
        var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        var cp = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
        cp.setAttribute('id', cid);
        var cr = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        cr.setAttribute('x', box.x); cr.setAttribute('y', box.y);
        cr.setAttribute('width', box.w); cr.setAttribute('height', box.h);
        cp.appendChild(cr); defs.appendChild(cp); svg.insertBefore(defs, im);
        im.setAttribute('clip-path', 'url(#' + cid + ')');
      }
      wrap.appendChild(svg);
      var sh = { i: i, el: svg, wrap: wrap, W: W, H: H, box: box, view: null };
      sheets[i] = sh;
      alignSheets();   // a sheet that loads after full screen was entered
      fit(sh);
      wireStage(sh);
      var loading = stage.querySelector('.ezp-schem__loading');
      if (loading) loading.remove();
      root.classList.add('is-ready');
      paintUnlisted();
      if (i === 0) sizeStage(sh);
    };
    img.onerror = function () { wrap.innerHTML = '<p class="ezp-schem__error">The drawing could not be loaded.</p>'; };
    img.src = def.src;
  }

  /* Where a caption sits and its leader line, in sheet px — the SAME rules
     as the hub's admin-ui/src/diagram-geometry.js captionBox (tested there);
     keep the two in step. s: {caption, capAt?, pts? | x, y, r} normalised;
     content = the sheet's content box in px. */
  function nearestOnPolygon(pts, px, py) {
    var best = null, bd = Infinity;
    for (var n = 0; n < pts.length; n++) {
      var a = pts[n], c = pts[(n + 1) % pts.length];
      var dx = c[0] - a[0], dy = c[1] - a[1], len2 = dx * dx + dy * dy;
      var t = len2 ? Math.max(0, Math.min(1, ((px - a[0]) * dx + (py - a[1]) * dy) / len2)) : 0;
      var x = a[0] + t * dx, y = a[1] + t * dy, d = Math.hypot(px - x, py - y);
      if (d < bd) { bd = d; best = { x: x, y: y }; }
    }
    return best;
  }
  function captionBox(s, W, H, fs, content) {
    var w = String(s.caption).length * fs * 0.56 + fs * 1.1;   // estimated: no layout before it is on screen
    var h = fs * 1.7;
    var poly = Array.isArray(s.pts) ? s.pts.map(function (p) { return [p[0] * W, p[1] * H]; }) : null;
    var at = s.capAt && isFinite(s.capAt.x) && isFinite(s.capAt.y) ? s.capAt : null;
    var x, y;
    if (at) { x = at.x * W - w / 2; y = at.y * H - h / 2; }
    else if (poly) {
      var xs = poly.map(function (p) { return p[0]; }), ys = poly.map(function (p) { return p[1]; });
      var top = Math.min.apply(null, ys);
      x = (Math.min.apply(null, xs) + Math.max.apply(null, xs)) / 2 - w / 2;
      y = top - h - fs * 0.4 < content.y ? top + fs * 0.4 : top - h - fs * 0.4;
    } else { x = s.x * W + s.r * W + fs * 0.5; y = s.y * H - h / 2; }
    x = Math.max(content.x, Math.min(x, content.x + content.w - w));
    y = Math.max(content.y, Math.min(y, content.y + content.h - h));
    var line = null;
    if (at) {
      var cx = x + w / 2, cy = y + h / 2, target;
      if (poly) target = nearestOnPolygon(poly, cx, cy);
      else {
        var ox = s.x * W, oy = s.y * H, rr = s.r * W, d = Math.hypot(cx - ox, cy - oy) || 1;
        target = { x: ox + ((cx - ox) / d) * rr, y: oy + ((cy - oy) / d) * rr };
      }
      var sx = Math.max(x, Math.min(target.x, x + w)), sy = Math.max(y, Math.min(target.y, y + h));
      if (Math.hypot(target.x - sx, target.y - sy) > fs * 0.8) line = [sx, sy, target.x, target.y];
    }
    return { x: x, y: y, w: w, h: h, line: line };
  }

  function circle(cx, cy, r, cls) {
    var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('cx', cx); c.setAttribute('cy', cy); c.setAttribute('r', r);
    c.setAttribute('class', cls);
    return c;
  }

  /** The stage takes the drawing's aspect ratio, within a height cap. */
  function sizeStage(sh) {
    var aspect = sh.box.w / sh.box.h;
    stage.style.aspectRatio = aspect.toFixed(4);
    stage.classList.toggle('is-portrait', aspect < 0.9);
  }

  /* ── view maths (mirrors the hub's admin viewer) ───────────────────── */
  var OVERHANG = 0.15, MAX_ZOOM = 8;
  var rectStr = function (v) { return [v.x, v.y, v.w, v.h].map(function (n) { return Math.round(n * 100) / 100; }).join(' '); };

  function clampView(v, box) {
    var w = Math.min(Math.max(v.w, box.w / MAX_ZOOM), box.w * (1 + OVERHANG * 2));
    var h = w * (v.h / v.w);
    var minX = box.x - w * OVERHANG, maxX = box.x + box.w - w * (1 - OVERHANG);
    var minY = box.y - h * OVERHANG, maxY = box.y + box.h - h * (1 - OVERHANG);
    return { x: Math.min(Math.max(v.x, minX), maxX), y: Math.min(Math.max(v.y, minY), maxY), w: w, h: h };
  }
  function setView(sh, v) { sh.view = clampView(v, sh.box); sh.el.setAttribute('viewBox', rectStr(sh.view)); updateZoomState(sh); }
  function fit(sh) { setView(sh, { x: sh.box.x, y: sh.box.y, w: sh.box.w, h: sh.box.h }); }
  function zoomLevel(sh) { return sh.box.w / sh.view.w; }
  function updateZoomState(sh) {
    var z = zoomLevel(sh) > 1.01;
    sh.wrap.classList.toggle('is-zoomed', z);
    // the stage carries it too, for the Reset pill (only the shown sheet)
    if (sh.i === active) stage.classList.toggle('is-zoomed', z);
    if (z) dropTip();
  }

  /** Zoom by factor keeping the drawing point under (px,py) fixed. */
  function zoomAt(sh, factor, px, py) {
    var v = sh.view;
    var p = px == null ? { x: v.x + v.w / 2, y: v.y + v.h / 2 } : svgPoint(sh, px, py);
    var w = v.w / factor, h = v.h / factor;
    setView(sh, { x: p.x - (p.x - v.x) / factor, y: p.y - (p.y - v.y) / factor, w: w, h: h });
  }
  /** Drawing units per screen pixel. "meet" letterboxes, so the LARGER of the
   *  two ratios is the real one — the width alone was right only while the
   *  stage had the drawing's own shape, which full screen does not. */
  function unitsPerPx(sh) {
    var r = sh.el.getBoundingClientRect();
    return Math.max(sh.view.w / (r.width || 1), sh.view.h / (r.height || 1));
  }
  function panBy(sh, dxPx, dyPx) {
    var scale = unitsPerPx(sh);
    setView(sh, { x: sh.view.x - dxPx * scale, y: sh.view.y - dyPx * scale, w: sh.view.w, h: sh.view.h });
  }
  function svgPoint(sh, clientX, clientY) {
    var pt = sh.el.createSVGPoint(); pt.x = clientX; pt.y = clientY;
    var m = sh.el.getScreenCTM();
    return m ? pt.matrixTransform(m.inverse()) : { x: sh.view.x, y: sh.view.y };
  }

  /* ── "Ctrl + scroll to zoom" veil (Nate, 2026-09-29, the Google Maps
     overlay). One look — a light 10% grey wash with a dark pill and a
     white key cap — shown at two moments, mouse devices only, never
     blocking a click (pointer-events: none):
       is-idle — on page load and whenever the mouse is NOT over the drawing.
                 Fades out the moment the mouse comes in.
       is-on   — a bare wheel over the drawing (which scrolls the PAGE, as it
                 should): the same veil back, the pill pulsing slightly, gone
                 ~1s after the scrolling stops or the moment they zoom. ── */
  var hint = null, hintTimer = null;
  if (!isTouch && stage) {
    hint = document.createElement('div');
    hint.className = 'ezp-schem__veil is-idle';
    hint.setAttribute('aria-hidden', 'true');
    var mac = /Mac|iPhone|iPad/i.test(navigator.platform || navigator.userAgent || '');
    var label = document.createElement('span');
    label.className = 'ezp-schem__veil-label';
    if (L.zoomHint) label.textContent = L.zoomHint;
    else {
      var key = document.createElement('span');
      key.className = 'ezp-schem__key';
      key.textContent = mac ? '⌘' : 'Ctrl';
      label.appendChild(key);
      label.appendChild(document.createTextNode('+ scroll to zoom'));
    }
    hint.appendChild(label);
    stage.appendChild(hint);
    stage.addEventListener('mouseenter', function () { hint.classList.remove('is-idle'); });
    stage.addEventListener('mouseleave', function () { hideHint(); hint.classList.add('is-idle'); });
    // already under the mouse when the page loads: no veil
    if (stage.matches(':hover')) hint.classList.remove('is-idle');
  }
  function showHint() {
    if (!hint) return;
    hint.classList.add('is-on');
    clearTimeout(hintTimer);
    hintTimer = setTimeout(hideHint, 1100);
  }
  function hideHint() { if (hint) { clearTimeout(hintTimer); hint.classList.remove('is-on'); } }

  /* The tip ON the drawing (2026-10-16, Nate: "pinch to zoom somewhere that
     fits"; the + / − buttons are gone). Worded for the device; it fades the
     first time the visitor zooms or opens a part, and stays gone. */
  var tip = stage && stage.querySelector('.ezp-schem__tip');
  if (tip) tip.textContent = isTouch
    ? (L.tipTouch || 'Pinch to zoom · tap a number')
    : (L.tipMouse || 'Click a number for the part · double-click to zoom');
  function dropTip() { if (tip) tip.classList.add('is-gone'); }

  /* ── gestures ──────────────────────────────────────────────────────── */
  function wireStage(sh) {
    var el = sh.el;
    var drag = null, moved = false, downHit = null, pinch = null;

    el.addEventListener('pointerdown', function (e) {
      // What the pointer is actually over is only knowable HERE. Once
      // setPointerCapture is on, Chrome retargets the compatibility mouse
      // events too, so the click below arrives with the <svg> as its target
      // and a circle is never found on it.
      downHit = e.target.closest ? e.target.closest('[data-legend]') : null;
      moved = false;
      if (e.pointerType === 'touch' && zoomLevel(sh) <= 1.01) return;   // let the page scroll at fit
      drag = { x: e.clientX, y: e.clientY, id: e.pointerId };
      el.setPointerCapture && el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id || pinch) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 3) moved = true;
      if (moved) { panBy(sh, dx, dy); drag.x = e.clientX; drag.y = e.clientY; }
    });
    var end = function () { drag = null; };
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);

    // clicks on circles (ignored after a drag); two quick clicks or taps on
    // the drawing itself zoom in there, as on a map
    var lastTap = null;
    el.addEventListener('click', function (e) {
      var t = (e.target.closest && e.target.closest('[data-legend]')) || downHit;
      downHit = null;
      if (moved) { moved = false; lastTap = null; return; }
      if (!t) {
        var now = e.timeStamp || Date.now();
        if (lastTap && now - lastTap.t < 350 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 40) {
          lastTap = null;
          zoomAt(sh, 2, e.clientX, e.clientY);
        } else lastTap = { t: now, x: e.clientX, y: e.clientY };
        return;
      }
      lastTap = null;
      e.stopPropagation();
      selectLegend(familyEntry(t.dataset.legend), { from: 'drawing', sheet: sh, at: { x: e.clientX, y: e.clientY } });
    });

    // ctrl/cmd + wheel zooms (a Mac trackpad pinch arrives this way too); a
    // bare wheel scrolls the page like anywhere else and flashes the hint
    el.addEventListener('wheel', function (e) {
      // in FULL SCREEN there is no page to scroll, so a plain wheel zooms
      // (2026-10-17, Nate); on the page it still scrolls and Ctrl/⌘ zooms
      if (!(e.ctrlKey || e.metaKey) && !isFocus()) { showHint(); return; }
      e.preventDefault();
      hideHint();
      if (e.ctrlKey || e.metaKey) { zoomAt(sh, e.deltaY < 0 ? 1.25 : 0.8, e.clientX, e.clientY); return; }
      // a plain wheel in full screen: in proportion to how far it turned — a
      // trackpad sends dozens of small events and a fixed step would fly
      var px = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * 400 : e.deltaY;
      zoomAt(sh, Math.max(0.8, Math.min(1.25, Math.exp(-px * 0.0018))), e.clientX, e.clientY);
    }, { passive: false });

    // pinch. The view is set ABSOLUTELY from the pinch's start: width =
    // start width ÷ how far the fingers have spread. The old code multiplied
    // the CURRENT view by that total spread on every touchmove, so a pinch
    // compounded dozens of times and flew to the zoom limit (Nate,
    // 2026-09-29: "much too sensitive"). The midpoint's travel pans, and a
    // one-finger pan in progress stops the moment the second finger lands.
    var mid = function (t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; };
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinch = { d: dist(e.touches), w: sh.view.w, mid: mid(e.touches) };
        drag = null; moved = true;   // no pan, and lifting is not a tap on a circle
      }
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!pinch || e.touches.length !== 2) return;
      e.preventDefault();
      var d = dist(e.touches), m = mid(e.touches);
      if (!pinch.d) { pinch.d = d; return; }
      var targetW = pinch.w * (pinch.d / d);
      zoomAt(sh, sh.view.w / targetW, m.x, m.y);
      panBy(sh, m.x - pinch.mid.x, m.y - pinch.mid.y);
      pinch.mid = m;
    }, { passive: false });
    el.addEventListener('touchend', function (e) { if (e.touches.length < 2) pinch = null; }, { passive: true });
    el.addEventListener('touchcancel', function () { pinch = null; }, { passive: true });
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }
  }

  stage.querySelectorAll('[data-zoom]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var sh = sheets[active]; if (!sh) return;
      if (b.dataset.zoom === 'in') zoomAt(sh, 1.6);
      else if (b.dataset.zoom === 'out') zoomAt(sh, 1 / 1.6);
      else { fit(sh); clearSelection(); }
    });
  });

  /* ── sheet tabs ────────────────────────────────────────────────────── */
  function showSheet(i) {
    if (!sheets[i] || i === active) return;
    active = i;
    root.querySelectorAll('.ezp-schem__sheet').forEach(function (w) { w.classList.toggle('is-active', Number(w.dataset.sheet) === i); });
    root.querySelectorAll('.ezp-schem__tab').forEach(function (t) {
      var on = Number(t.dataset.sheet) === i;
      t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    sizeStage(sheets[i]);
    updateZoomState(sheets[i]);
    markSection(i);
    // the tab row scrolls sideways on phones: bring the active tab into it
    // (scrollLeft, not scrollIntoView, which could move the page as well)
    var on = root.querySelector('.ezp-schem__tab.is-active');
    var row = on && on.parentNode;
    if (row && row.scrollWidth > row.clientWidth) {
      var left = on.offsetLeft - row.offsetLeft - 16;
      if (row.scrollTo) row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); else row.scrollLeft = Math.max(0, left);
    }
  }
  // the list's heading for the page on show
  function markSection(i) {
    sectionHeads.forEach(function (s) {
      var pages = String(s.el.dataset.sheets || '').split(',').filter(Boolean).map(Number);
      s.el.classList.toggle('is-current', pages.indexOf(i) !== -1);
    });
  }
  markSection(0);
  // a section heading brings its page up (only a page that has loaded)
  list.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.ezp-sect[data-sheet]');
    if (h) showSheet(Number(h.dataset.sheet));
  });
  root.querySelectorAll('.ezp-schem__tab').forEach(function (t) {
    t.addEventListener('click', function () { showSheet(Number(t.dataset.sheet)); });
  });

  /* ── selection: rows <-> circles ───────────────────────────────────── */
  var selected = null;

  function clearSelection() {
    selected = null;
    root.querySelectorAll('.is-selected').forEach(function (el) { el.classList.remove('is-selected'); });
  }
  function setHot(k, on) {
    (circlesByLegend[k] || []).forEach(function (c) { c.el.classList.toggle('is-hot', on); });
    rowsFor(k).forEach(function (li) { li.classList.toggle('is-hot', on); });
  }
  function rowsFor(k) {
    return Array.prototype.filter.call(list.querySelectorAll('.ezp-part'), function (li) { return normLegend(li.dataset.legend) === k; });
  }

  /**
   * Either side opens the drawer (Nate, 2026-09-18) — a circle and its legend
   * row are the same thing to a shopper. Beyond that:
   *   from 'drawing': highlight the rows, but never scroll to them — the
   *   drawer shows the part (Nate, 2026-09-29: the scroll moved the page);
   *   from 'list': highlight the circles and bring their sheet up, but never
   *   move the view — no auto-zoom (Nate, 2026-09-23).
   */
  function selectLegend(k, opts) {
    clearSelection();
    selected = k;
    var circles = circlesByLegend[k] || [];
    var rows = rowsFor(k);
    circles.forEach(function (c) { c.el.classList.add('is-selected'); });
    rows.forEach(function (li) { li.classList.add('is-selected'); });
    dropTip();
    openDrawer(k);
    if (opts.from === 'drawing' && keepCalloutVisible) {
      // the page was zoomed and is snapping back (resetPageZoom): measure
      // once it has, and the tap's coordinates no longer mean anything
      if (viewportRestore) setTimeout(function () { keepCalloutVisible(k, null); }, 400);
      else keepCalloutVisible(k, opts.at);
    }

    // A circle click does NOT scroll the parts list to its row any more (Nate,
    // 2026-09-29): where the list is not its own scroll box, scrollIntoView
    // moved the whole PAGE, which read as a jump, and the drawer already shows
    // the part. The row is still highlighted (is-selected) for when it closes.
    // A list click still brings the drawing to the right sheet.
    if (opts.from !== 'drawing' && circles.length && !circles.some(function (c) { return c.sheet === active; })) {
      showSheet(circles[0].sheet);
    }
  }

  /**
   * Anywhere else closes the drawer. Three reasons this listens in the CAPTURE
   * phase on the whole document rather than checking `root.contains(target)`:
   * the drawer, the drawing and the list all live INSIDE root (so that test
   * ignored most of the page), theme components stop propagation on their own
   * clicks (so a bubbling listener only fired in some spots), and with pointer
   * capture on the svg a circle click reports the <svg> as its target.
   */
  function keepsDrawerOpen(t) {
    if (!t || !t.closest) return false;
    if (drawer && drawer.contains(t)) return true;
    // Anything on the drawing keeps it open: a number tapped there SWAPS the
    // parts (the stage's own click handler), and empty drawing is where people
    // pan. Pointer capture reports every drawing click as the <svg>, so this
    // used to read a tap on another number as "outside": the drawer closed via
    // history.back() a moment AFTER it had swapped (2026-10-06).
    if (t.closest('.ezp-schem__stage')) return true;
    return !!(t.closest('[data-legend]') || t.closest('.ezp-part')
      || t.closest('.ezp-schem__controls') || t.closest('.ezp-schem__tabs')
      || t.closest('.ezp-schem__search'));
  }
  document.addEventListener('click', function (e) {
    if (keepsDrawerOpen(e.target)) return;
    if (drawerLegend) { if (!usePanel()) dismissDrawer(); }   // the docked panel stays until ✕ / Esc / back
    else clearSelection();
  }, true);

  /* ── legend list: enhance rows, hover, click, search ───────────────── */
  list.addEventListener('mouseover', function (e) { var li = e.target.closest('.ezp-part'); if (li) setHot(normLegend(li.dataset.legend), true); });
  list.addEventListener('mouseout', function (e) { var li = e.target.closest('.ezp-part'); if (li) setHot(normLegend(li.dataset.legend), false); });
  list.addEventListener('click', function (e) {
    if (e.target.closest('a, button')) return;
    var li = e.target.closest('.ezp-part');
    if (li) selectLegend(normLegend(li.dataset.legend), { from: 'list' });
  });
  stage.addEventListener('mouseover', function (e) { var t = e.target.closest && e.target.closest('[data-legend]'); if (t) setHot(t.dataset.legend, true); });
  stage.addEventListener('mouseout', function (e) { var t = e.target.closest && e.target.closest('[data-legend]'); if (t) setHot(t.dataset.legend, false); });

  var search = document.getElementById('ezp-schem-search');
  var empty = root.querySelector('.ezp-schem__empty');
  if (search) {
    search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      var shown = 0;
      list.querySelectorAll('.ezp-part').forEach(function (li) {
        var on = !q || (li.dataset.search || '').indexOf(q) !== -1;
        li.hidden = !on;
        // a part not on the site is never in the side list (css), so it does
        // not count as a match — else "no parts match" would never show
        if (on && !li.classList.contains('is-uncarried') && !li.classList.contains('is-unlisted')) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      paintSections();
    });
  }

  /* ── products: prices, stock, images, add to cart ──────────────────── */
  var products = [], skuMap = {}, finalSale = {};

  function fetchAllProducts(handle, cb) {
    var out = [], page = 1;
    (function next() {
      fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var batch = d.products || [];
          out = out.concat(batch);
          if (batch.length === 250 && page < 20) { page++; next(); } else cb(out);
        })
        .catch(function () { cb(out); });
    })();
  }

  function money(v) { var n = parseFloat(v); return isFinite(n) ? '$' + n.toFixed(2) : ''; }

  function enhanceRows() {
    products.forEach(function (p) {
      // vendor-hub's item-status push tags a non-returnable part
      // status-final-sale (theme/product-status); the cart line then says so,
      // as it does from the product page
      var fs = (p.tags || []).indexOf('status-final-sale') !== -1;
      (p.variants || []).forEach(function (v) {
        if (v.sku) skuMap[String(v.sku).trim().toLowerCase()] = { p: p, v: v };
        if (fs) finalSale[v.id] = true;
      });
    });
    unlistedLegends = {};
    Object.keys(rowsByLegend).forEach(function (k) { unlistedLegends[k] = true; });

    list.querySelectorAll('.ezp-part').forEach(function (li) {
      var hit = skuMap[String(li.dataset.sku || '').trim().toLowerCase()];
      var k = normLegend(li.dataset.legend);
      var stock = li.querySelector('.ezp-part__stock');
      var cta = li.querySelector('.ezp-part__cta');
      var imgWrap = li.querySelector('.ezp-part__img');
      if (!hit) {
        if (!li.classList.contains('is-uncarried')) {
          li.classList.add('is-unlisted');
          if (cta && !cta.textContent.trim()) cta.innerHTML = '<span class="ezp-part__na">' + esc(L.unlisted || 'Not currently listed') + '</span>';
        }
        return;
      }
      unlistedLegends[k] = false;
      var p = hit.p, v = hit.v;
      // The storefront is the truth: a part on the site is buyable (or out of
      // stock) whatever schem_json said when the collection was last synced.
      // Its carried/listed flags are frozen at sync time and only pick the
      // wording for a part that is NOT on the site (R0458200 was listed and
      // in stock but still greyed "Not available", 2026-09-23).
      li.classList.remove('is-uncarried', 'is-unlisted');
      li.classList.add('is-listed');
      li.classList.toggle('is-oos', !v.available);
      var titleEl = li.querySelector('.ezp-part__title');
      // no links on the row (Nate, 2026-10-06): a click ANYWHERE on it opens
      // the part, which has its own "View full details" link
      if (titleEl) titleEl.textContent = p.title;
      var img = p.images && p.images[0] && p.images[0].src;
      if (imgWrap && img) imgWrap.innerHTML = '<img src="' + esc(sized(img, 120)) + '" alt="' + esc(p.title) + '" loading="lazy" width="52" height="52">';
      if (stock) stock.innerHTML = v.available
        ? '<span class="ezp-stock is-in">✓ ' + esc(L.inStock || 'In stock') + '</span>'
        : '<span class="ezp-stock is-out">✕ ' + esc(L.outOfStock || 'Out of stock') + '</span>';
      if (cta) cta.innerHTML = '<span class="ezp-part__price">' + money(v.price) + ' <span class="ezp-part__ea">/ea</span></span>'
        + (v.available ? '<button type="button" class="ezp-atc" data-variant-id="' + v.id + '">' + esc(L.add || 'Add to Cart') + '</button>' : '');
    });

    paintUnlisted();   // a callout none of whose parts are on the site: greyed circle
    paintSections();   // rows just learned they are not on the site
    root.classList.add('has-products');
    if (drawerLegend) openDrawer(drawerLegend);   // opened before the prices landed
    else openFromHash();                           // a link to #part-6
    skuMapReady = true;
    preloadAll();
    document.dispatchEvent(new CustomEvent('ezpSchemProductsReady', { detail: { products: products } }));
  }

  /** Shopify CDN: ask for a small rendition. */
  function sized(src, w) { return src.indexOf('?') === -1 ? src + '?width=' + w : src + '&width=' + w; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ezp-atc');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var qIn = btn.parentNode && btn.parentNode.querySelector('.ezp-qty input');
    addToCart(parseInt(btn.dataset.variantId, 10), btn, qIn ? Math.min(99, Math.max(1, parseInt(qIn.value, 10) || 1)) : 1);
  });

  /* The cart icon and drawer are refreshed the way the theme's own product
     form does it: /cart/add.js is asked to return the re-rendered sections
     (`sections`), and the <cart-drawer> element's renderContents() swaps them
     in — the drawer AND #cart-icon-bubble. The old pages fired
     'dispatch:cart-drawer:refresh', which this theme's drawer never listens
     for, and patched a .header__cart-count-number that does not exist while
     the cart is empty — so the first item never showed until a reload. */
  function cartDrawer() {
    var d = document.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' ? d : null;
  }

  /** No drawer (cart type "page"), or it failed: re-render the bubble alone. */
  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        var html = s && s['cart-icon-bubble'];
        if (!el || !html) return;
        var t = document.createElement('template');
        t.innerHTML = html;
        var inner = t.content.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : html;
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn, qty) {
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    var drawer = cartDrawer();
    var sections = ['cart-icon-bubble'];
    try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.section; }); } catch (e) {}
    var item = { id: variantId, quantity: qty || 1 };
    if (finalSale[variantId]) item.properties = { 'Final sale': 'Yes – non-returnable' };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (data) {
        btn.textContent = '✓ Added'; btn.classList.add('is-ok');
        // the theme's cart drawer is outside this section, so it cannot show
        // over full screen: leave it first when the drawer is set to open
        if (DATA.openCart && isFocus()) exitFocus();
        if (drawer && data && data.sections) {
          Promise.resolve()
            .then(function () { return drawer.renderContents(data, !!DATA.openCart); })
            .catch(refreshBubble);
        } else {
          refreshBubble();
        }
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-ok'); btn.disabled = false; }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error — retry'; btn.classList.add('is-err'); btn.disabled = false;
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-err'); }, 2500);
      });
  }

  /* ── drawer (every screen size — the old page's part cards) ────────── */
  var drawerLegend = null;

  /** The first few sentences of a product description, as plain text. */
  function excerpt(html, max) {
    var t = document.createElement('div');
    t.innerHTML = String(html || '');
    // a <style> / <script> pasted into a description is not words (2026-10-17:
    // the E30 cable's card read "/* Paste this inside your <style> tags */…")
    Array.prototype.slice.call(t.querySelectorAll('style, script, noscript, template')).forEach(function (n) { n.remove(); });
    var s = (t.textContent || '').replace(/\s+/g, ' ').trim();
    if (s.length <= max) return s;
    s = s.slice(0, max);
    return s.slice(0, Math.max(s.lastIndexOf(' '), max - 20)).replace(/[,;:.\s]+$/, '') + '…';
  }

  /** One display row per legend row, listed parts first (the old order). */
  function drawerParts(k) {
    return (rowsByLegend[k] || []).map(function (r) {
      var hit = skuMap[String(r.sku || '').trim().toLowerCase()];
      var p = hit && hit.p, v = hit && hit.v;
      return {
        sku: r.sku || '',
        option: r.option ? String(r.option) : '',
        title: p ? p.title : (r.description || r.sku || ''),
        desc: (p && excerpt(p.body_html, 260)) || r.description || '',
        handle: p ? p.handle : '',
        img: (p && p.images && p.images[0] && p.images[0].src) || '',
        price: v ? money(v.price) : '',
        available: !!(v && v.available),
        variantId: v ? v.id : 0,
        note: p ? (v && v.available ? '' : (L.outOfStock || 'Out of stock'))
               : (r.carried === false ? (L.uncarried || 'Not available') : (L.unlisted || 'Not currently listed'))
      };
    }).sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
  }

  /* A part card — the drawer, the phone sheet and the desktop panel all use
     it. Nothing on it is a link except "View full details" (Nate,
     2026-10-06): the photo and the title used to open the product in a NEW
     tab, and a click meant to close the drawer kept landing on one. The one
     link opens in the same tab, so back returns here with the part open. */
  var PART_IMG = 480;   // one size for every card, so a preload serves all of them
  function drawerCard(d) {
    var link = d.handle ? '/products/' + esc(d.handle) : '';
    return '<div class="ezp-dpart">'
      + '<div class="ezp-dpart__inner">'
        + (d.img
            ? '<div class="ezp-dpart__img"><img src="' + esc(sized(d.img, PART_IMG)) + '" alt="' + esc(d.title)
              + '" width="240" height="240" decoding="async"></div>'
            : '')
        + '<div class="ezp-dpart__details">'
          + '<h6 class="ezp-dpart__title">' + esc(d.title) + '</h6>'
          + (d.sku ? '<p class="ezp-dpart__sku"><span>SKU</span> ' + esc(d.sku) + '</p>' : '')
          + (d.price ? '<p class="ezp-dpart__price">' + d.price + ' <span class="ezp-dpart__ea">/ea</span>'
              + (d.available ? ' <span class="ezp-stock is-in">✓ ' + esc(L.inStock || 'In stock') + '</span>' : '') + '</p>' : '')
        + '</div>'
      + '</div>'
      + (d.desc ? '<p class="ezp-dpart__desc">' + esc(d.desc) + '</p>' : '')
      + '<div class="ezp-dpart__footer">'
        + (d.available && d.variantId
            ? '<div class="ezp-qty"><button type="button" data-step="-1" aria-label="Fewer">−</button>'
              + '<input type="number" min="1" max="99" value="1" inputmode="numeric" aria-label="Quantity">'
              + '<button type="button" data-step="1" aria-label="More">+</button></div>'
              + '<button type="button" class="ezp-atc" data-variant-id="' + d.variantId + '">' + esc(L.add || 'Add to Cart') + '</button>'
            : '<span class="ezp-dpart__na">' + esc(d.note || L.unlisted || 'Not currently listed') + '</span>')
      + '</div>'
      + (link ? '<a class="ezp-dpart__link" href="' + link + '">' + esc(L.details || 'View full details') + ' &rarr;</a>' : '')
    + '</div>';
  }

  /* Wide screens (two columns, 1024px+) show the part in a PANEL at the top
     of the right-hand column instead of the drawer (Nate, 2026-10-06): no
     overlay, so the drawing stays clickable and another number simply swaps
     it, and nothing has to be closed to get on. Narrower screens keep the
     drawer (768-1023px) or the bottom sheet (phones). */
  var panelQuery = window.matchMedia('(min-width: 1024px)');
  var legendCol = root.querySelector('.ezp-schem__legend-col');
  var panel = null;
  if (legendCol) {
    panel = document.createElement('div');
    panel.className = 'ezp-schem__panel';
    panel.hidden = true;
    panel.innerHTML = '<button type="button" class="ezp-schem__panel-close" aria-label="Close">&times;</button>'
      + '<div class="ezp-schem__panel-body"></div>';
    legendCol.insertBefore(panel, legendCol.firstChild);
    panel.querySelector('.ezp-schem__panel-close').addEventListener('click', function (e) { e.stopPropagation(); dismissDrawer(); });
  }
  var usePanel = function () { return !!panel && panelQuery.matches; };

  /** The numbers in list order, for ‹ › (only rows the list shows). */
  function legendOrder() {
    var seen = {}, out = [];
    list.querySelectorAll('.ezp-part').forEach(function (li) {
      var k = normLegend(li.dataset.legend);
      if (familyOf[k]) k = familyOf[k].keys[0];   // a family is one stop
      if (seen[k] || li.hidden || getComputedStyle(li).display === 'none') return;
      seen[k] = true; out.push(k);
    });
    return out;
  }
  function stepLegend(dir) {
    var order = legendOrder();
    var here = familyOf[drawerLegend] ? familyOf[drawerLegend].keys[0] : drawerLegend;
    var i = order.indexOf(here);
    if (i === -1 || !order.length) return;
    var k = order[(i + dir + order.length) % order.length];
    selectLegend(familyEntry(k), { from: 'list' });
  }

  /** The family's first row of chips: one per sub-number, its label from
   *  the hub ("7a · C250 · 25 sq ft"), dimmed when nothing under it is sold. */
  function variantChips(fam, k) {
    var dim = '';
    var chips = fam.keys.map(function (sk) {
      var rows = rowsByLegend[sk] || [];
      var withLabel = rows.filter(function (r) { return r.variant; })[0];
      if (!dim && withLabel && withLabel.variantDim) dim = withLabel.variantDim;
      var sold = drawerParts(sk).some(function (d) { return d.handle; });
      var name = rows[0] ? String(rows[0].legend) : sk;
      return '<button type="button" role="tab" class="ezp-opt ezp-var' + (sk === k ? ' is-on' : '') + (sold ? '' : ' is-oos')
        + '" data-var="' + esc(sk) + '" aria-selected="' + (sk === k) + '">'
        + '<b>' + esc(name) + '</b>' + (withLabel ? ' ' + esc(withLabel.variant) : '') + '</button>';
    }).join('');
    return '<div class="ezp-opts ezp-opts--variant" role="tablist" aria-label="' + esc(dim || L.chooseVariant || 'Version') + '">'
      + '<span class="ezp-opts__label">' + esc(dim || L.chooseVariant || 'Version') + '</span>' + chips + '</div>';
  }

  /* What a number shows (Nate, 2026-10-06):
     - ONE card. A number with several options on the site (the H-Series
       heater's number 3 is five heat exchangers, H150 to H400) gets a row of
       choice chips above that card instead of five near-identical cards
       stacked up. The chip says what DIFFERS between the titles
       (optionLabels): the model numbers when those alone tell them apart,
       else the differing words, else the SKU.
     - Parts we do not sell are folded under "+ N not sold here", closed by
       default, as plain one-line rows (no photo, no button). When nothing
       for the number is on the site those rows are all there is, shown
       open. */
  var optionPick = {};      // number -> chosen option index
  var showUnsold = false;   // the "not sold here" rows, for the whole visit

  function optionLabels(items) {
    var toks = items.map(function (d) {
      return String(d.title || '').split('|')[0].replace(/[(),]/g, ' ').replace(/\b([A-Za-z]{1,3})-(?=\d)/g, '$1').split(/[\s\-\u2013\/]+/).filter(Boolean);
    });
    var lc = toks.map(function (ts) { return ts.map(function (w) { return w.toLowerCase(); }); });
    var common = (lc[0] || []).filter(function (w) { return lc.every(function (ts) { return ts.indexOf(w) !== -1; }); });
    var filler = ['to', 'and', 'for', 'with', 'the', 'of', 'a', 'an', '&', 'w'];
    var rest = toks.map(function (ts, i) {
      return ts.filter(function (w, j) { return common.indexOf(lc[i][j]) === -1 && filler.indexOf(lc[i][j]) === -1; });
    });
    var unique = function (labels) {
      var seen = {};
      return labels.every(function (l) { var x = l.toLowerCase(); if (!x || seen[x]) return false; seen[x] = true; return true; });
    };
    var models = rest.map(function (ts) { return ts.filter(function (w) { return /\d/.test(w); }).join(' '); });
    if (unique(models)) return models;                                  // H150 / H200 / H250
    var words = rest.map(function (ts) { return ts.slice(0, 3).join(' '); });
    if (unique(words)) return words;                                    // Natural DS / Propane MV
    // every differing word, before falling back to a bare SKU (a row of
    // SKUs tells a shopper nothing — Nate, 2026-10-16)
    var all = rest.map(function (ts) { return ts.slice(0, 6).join(' '); });
    if (unique(all)) return all;
    return items.map(function (d, i) { return d.sku || words[i] || ('Option ' + (i + 1)); });
  }

  function unsoldRow(d) {
    return '<li class="ezp-unsold__row"><span class="ezp-unsold__title">' + esc(d.title) + '</span>'
      + (d.sku ? ' <span class="ezp-unsold__sku">' + esc(d.sku) + '</span>' : '')
      + ' <span class="ezp-unsold__note">' + esc(d.note || L.uncarried || 'Not available') + '</span></li>';
  }

  /* "Not Shown" is not ONE part with options: it is every part the vendor
     lists with no number on the drawing — gaskets next to whole pumps. So it
     is a LIST of compact rows, each its own price and Add to Cart, never a
     row of option chips (Nate, 2026-10-16: the chips read as random SKUs). */
  var isNotShown = function (k) { return /^not\s*shown$/i.test(String(k || '').trim()); };
  function miniRow(d) {
    var link = d.handle ? '/products/' + esc(d.handle) : '';
    return '<li class="ezp-mini">'
      + '<div class="ezp-mini__img">' + (d.img ? '<img src="' + esc(sized(d.img, 160)) + '" alt="' + esc(d.title) + '" width="64" height="64" loading="lazy">' : '') + '</div>'
      + '<div class="ezp-mini__info">'
        // like the card: the title is not a link, "Details" is (2026-10-06 rule)
        + '<span class="ezp-mini__title">' + esc(d.title) + '</span>'
        + '<span class="ezp-mini__sku">' + (d.sku ? 'SKU ' + esc(d.sku) : '')
          + (link ? ' <a class="ezp-mini__link" href="' + link + '">' + esc(L.detailsShort || 'Details') + ' &rarr;</a>' : '') + '</span>'
        + '<span class="ezp-mini__buy">'
          + (d.price ? '<span class="ezp-mini__price">' + d.price + '</span>' : '')
          + (d.available && d.variantId
              ? '<button type="button" class="ezp-atc" data-variant-id="' + d.variantId + '">' + esc(L.add || 'Add to Cart') + '</button>'
              : '<span class="ezp-dpart__na">' + esc(d.note || L.outOfStock || 'Out of stock') + '</span>')
        + '</span>'
      + '</div>'
    + '</li>';
  }

  function partsHtml(k) {
    var all = drawerParts(k);
    var sold = all.filter(function (d) { return d.handle; });
    var unsold = all.filter(function (d) { return !d.handle; });
    if (!sold.length) {
      return { chips: '', html: '<p class="ezp-unsold__lead">' + esc(L.noneSold || 'This part is not sold on our site.') + '</p>'
        + '<ul class="ezp-unsold">' + unsold.map(unsoldRow).join('') + '</ul>' };
    }
    if (isNotShown(k)) {
      var html0 = '<p class="ezp-mini__lead">' + esc(L.notShownLead || 'Listed for this model but not numbered on the drawing.') + '</p>'
        + '<ul class="ezp-minis">' + sold.map(miniRow).join('') + '</ul>';
      if (unsold.length) {
        html0 += '<button type="button" class="ezp-unsold__toggle" aria-expanded="' + showUnsold + '">'
          + (showUnsold ? '&minus; ' : '+ ') + unsold.length + ' ' + esc(L.notSoldHere || 'not sold here') + '</button>'
          + (showUnsold ? '<ul class="ezp-unsold">' + unsold.map(unsoldRow).join('') + '</ul>' : '');
      }
      return { chips: '', html: html0 };
    }
    // chips read in natural order (H150, H200 … H400), and the card opens
    // on the first one in stock unless the visitor picked one already
    // The hub's labels (schem_json `option`: written by AI from the parts'
    // specs, or typed on the run page — 2026-10-16) when EVERY part on the
    // site has one; otherwise the word-difference rule, so a page synced
    // before the labels existed still gets readable chips.
    var hubLabels = sold.every(function (d) { return d.option; });
    var labels = sold.length > 1 ? (hubLabels ? sold.map(function (d) { return d.option; }) : optionLabels(sold)) : [''];
    if (sold.length > 1) {
      var order = sold.map(function (d, i) { return i; }).sort(function (a, b) {
        return labels[a].localeCompare(labels[b], undefined, { numeric: true, sensitivity: 'base' });
      });
      sold = order.map(function (i) { return sold[i]; });
      labels = order.map(function (i) { return labels[i]; });
    }
    var firstInStock = Math.max(0, sold.findIndex(function (d) { return d.available; }));
    var pick = Math.min(optionPick[k] != null ? optionPick[k] : firstInStock, sold.length - 1);
    var chips = '', html = '';
    if (sold.length > 1) {
      chips = '<div class="ezp-opts" role="tablist" aria-label="' + esc(L.options || 'Options') + '">'
        + '<span class="ezp-opts__label">' + esc(L.chooseOption || 'Options') + '</span>'
        + sold.map(function (d, i) {
          return '<button type="button" role="tab" class="ezp-opt' + (i === pick ? ' is-on' : '') + (d.available ? '' : ' is-oos')
            + '" data-opt="' + i + '" aria-selected="' + (i === pick) + '" title="' + esc(d.title) + '">' + esc(labels[i]) + '</button>';
        }).join('')
        + '</div>';
    }
    html += drawerCard(sold[pick]);
    if (unsold.length) {
      html += '<button type="button" class="ezp-unsold__toggle" aria-expanded="' + showUnsold + '">'
        + (showUnsold ? '&minus; ' : '+ ') + unsold.length + ' ' + esc(L.notSoldHere || 'not sold here') + '</button>'
        + (showUnsold ? '<ul class="ezp-unsold">' + unsold.map(unsoldRow).join('') + '</ul>' : '');
    }
    return { chips: chips, html: html };
  }

  function openDrawer(k) {
    var inPanel = usePanel();
    if (!inPanel && !drawer) return;
    var first = (rowsByLegend[k] || [])[0];
    var fam = familyOf[k];
    if (fam) familyPick[fam.base] = k;
    var multi = legendOrder().length > 1;
    var parts = partsHtml(k);
    var head = '<div class="ezp-schem__drawer-top"><div class="ezp-schem__toprow">'
      + (multi ? '<button type="button" class="ezp-schem__step" data-dir="-1" aria-label="Previous part">&lsaquo;</button>' : '')
      + '<h4 class="ezp-schem__drawer-head">' + (isNotShown(k)
          ? esc(L.notShown || 'Not on the drawing')
          : esc(L.legend || 'Legend #') + esc(fam ? fam.base : (first ? first.legend : k))) + '</h4>'
      + (multi ? '<button type="button" class="ezp-schem__step" data-dir="1" aria-label="Next part">&rsaquo;</button>' : '')
      + '<button type="button" class="ezp-schem__x" aria-label="Close">&times;</button>'
      + '</div>' + (fam ? variantChips(fam, k) : '') + parts.chips + '</div>';
    var box = inPanel ? panel : drawer;
    var body = box.querySelector(inPanel ? '.ezp-schem__panel-body' : '.ezp-schem__drawer-body');
    var swapped = drawerLegend !== null && drawerLegend !== k;
    drawerLegend = k;
    body.innerHTML = head + parts.html;
    if (swapped) { body.scrollTop = 0; box.scrollTop = 0; }
    if (inPanel) {
      panel.hidden = false;
      if (drawer) { drawer.classList.remove('is-open', 'is-full'); drawer.setAttribute('aria-hidden', 'true'); }
    } else {
      if (panel) panel.hidden = true;
      if (!drawer.classList.contains('is-open')) { resetPageZoom(); sizePeek(); }
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    }
    remember(k);
  }
  function closeDrawer() {
    drawerLegend = null;
    if (drawer) { drawer.classList.remove('is-open', 'is-full'); drawer.setAttribute('aria-hidden', 'true'); }
    if (panel) panel.hidden = true;
  }
  // the window crossing 1024px moves an open part between panel and drawer
  var onPanelQuery = function () { if (drawerLegend) openDrawer(drawerLegend); };
  if (panelQuery.addEventListener) panelQuery.addEventListener('change', onPanelQuery);
  else if (panelQuery.addListener) panelQuery.addListener(onPanelQuery);

  // a soft shadow under the pinned header once something scrolls under it
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.classList || !root.contains(el)) return;
    if (el === panel || el === drawer || el.classList.contains('ezp-schem__drawer-body')) {
      el.classList.toggle('is-scrolled', el.scrollTop > 2);
    }
  }, true);

  // ‹ › and the quantity stepper, wherever the card is
  root.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('.ezp-schem__step');
    if (step) { e.stopPropagation(); stepLegend(Number(step.dataset.dir)); return; }
    if (e.target.closest && e.target.closest('.ezp-schem__x')) { e.stopPropagation(); dismissDrawer(); return; }
    var vchip = e.target.closest && e.target.closest('.ezp-var');
    if (vchip && drawerLegend) { e.stopPropagation(); selectLegend(vchip.dataset.var, { from: 'list' }); return; }
    var opt = e.target.closest && e.target.closest('.ezp-opt');
    if (opt && drawerLegend) { optionPick[drawerLegend] = Number(opt.dataset.opt); openDrawer(drawerLegend); return; }
    if (e.target.closest && e.target.closest('.ezp-unsold__toggle') && drawerLegend) { showUnsold = !showUnsold; openDrawer(drawerLegend); return; }
    var q = e.target.closest && e.target.closest('.ezp-qty [data-step]');
    if (q) {
      var input = q.parentNode.querySelector('input');
      input.value = Math.min(99, Math.max(1, (parseInt(input.value, 10) || 1) + Number(q.dataset.step)));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!drawerLegend || !usePanel() && !(drawer && drawer.classList.contains('is-open'))) return;
    var el = e.target;
    if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable)) return;
    if (e.key === 'ArrowRight') { stepLegend(1); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { stepLegend(-1); e.preventDefault(); }
  });

  /* Photos load before they are asked for (Nate, 2026-10-06). Once the page
     is idle, every listed part's card photo is fetched at the one size the
     cards use, so a card opens with its picture already there; a hover over
     a number or a row fetches that part's photo at once in case the idle
     pass has not reached it. Skipped when the visitor asked to save data. */
  var preloaded = {};
  function preloadSrc(src) {
    if (!src || preloaded[src]) return;
    preloaded[src] = true;
    var im = new Image(); im.decoding = 'async'; im.src = src;
  }
  function preloadLegend(k) {
    drawerParts(k).forEach(function (d) { if (d.img) preloadSrc(sized(d.img, PART_IMG)); });
  }
  function preloadAll() {
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    var keys = Object.keys(rowsByLegend).slice(0, 80);
    var go = function () { keys.forEach(preloadLegend); };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
  }
  stage.addEventListener('pointerover', function (e) { var t = e.target.closest && e.target.closest('[data-legend]'); if (t && skuMapReady) preloadLegend(t.dataset.legend); });
  list.addEventListener('pointerover', function (e) { var li = e.target.closest('.ezp-part'); if (li && skuMapReady) preloadLegend(normLegend(li.dataset.legend)); });
  var skuMapReady = false;

  /* ── the back button closes the drawer (2026-10-06) ──────────────────
     On a phone, back is how people dismiss things; it used to leave the
     page. Opening pushes ONE history entry (#part-6); tapping another
     number REPLACES it, so back always returns to the bare diagram rather
     than walking every part looked at. Closing by hand goes back over our
     own entry, so the history stays as it was before the drawer opened.
     A link to …#part-6 opens straight on that part. */
  var HASH = /^#part-(.+)$/;
  var pushedHere = false;   // the entry under us is one this page pushed
  function partUrl(k) { return location.pathname + location.search + (k ? '#part-' + encodeURIComponent(k) : ''); }
  function remember(k) {
    // a part opened in full screen carries the focus flag, so going back from
    // it lands on the focus entry and stays in full screen (see FULL SCREEN)
    var st = isFocus() ? { ezpPart: k, ezpFocus: true } : { ezpPart: k };
    if (history.state && history.state.ezpPart) {
      if (history.state.ezpPart !== k) history.replaceState(st, '', partUrl(k));
      return;
    }
    // Going back over our own entry must not move the page: the browser
    // would restore the scroll it saved when the entry was pushed, so a page
    // the customer scrolled (or #7 scrolled for them) jumped back on close.
    // The mode belongs to the entry, so set it before pushing; popstate and
    // pagehide put it back to auto, so leaving for a product page and coming
    // back still restores the scroll.
    try { history.scrollRestoration = 'manual'; } catch (e) { /* old browser */ }
    history.pushState(st, '', partUrl(k));
    pushedHere = true;
  }
  window.addEventListener('pagehide', function () { try { history.scrollRestoration = 'auto'; } catch (e) { /* */ } });
  // the page zoom when ✕ was pressed: going back over our entry makes iOS
  // restore the zoom that entry was pushed at, so a page the visitor had
  // zoomed back out to 100% zoomed IN again on close (Nate, 2026-10-16)
  var closingScale = null;
  function dismissDrawer() {
    if (pushedHere && history.state && history.state.ezpPart) {   // popstate closes
      closingScale = window.visualViewport ? window.visualViewport.scale : null;
      history.back(); return;
    }
    closeDrawer(); clearSelection();
    if (HASH.test(location.hash) || (history.state && history.state.ezpPart)) history.replaceState(isFocus() ? { ezpFocus: true } : null, '', partUrl(''));
  }
  window.addEventListener('popstate', function (e) {
    var k = e.state && e.state.ezpPart;
    if (k && rowsByLegend[k]) { pushedHere = true; selectLegend(k, { from: 'list' }); return; }   // forward again
    if (drawerLegend) { closeDrawer(); clearSelection(); }
    // a browser that restores anyway (the mode is ignored) is put back
    var y = window.scrollY;
    var wanted = closingScale; closingScale = null;
    requestAnimationFrame(function () {
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
      try { history.scrollRestoration = 'auto'; } catch (e) { /* */ }
    });
    // closed at 100% but the browser brought the old zoom back: undo it
    if (wanted != null && wanted <= 1.01) {
      setTimeout(function () {
        var vv = window.visualViewport;
        if (vv && vv.scale > 1.01) resetPageZoom();
      }, 60);
    }
  });
  function openFromHash() {
    var m = HASH.exec(location.hash);
    if (!m) return;
    var k = normLegend(decodeURIComponent(m[1]));
    if (!rowsByLegend[k] && familyByBase[k]) k = familyByBase[k].keys[0];
    if (!rowsByLegend[k]) return;
    history.replaceState({ ezpPart: k }, '', partUrl(k));   // not pushed here: closing must not leave the page
    selectLegend(k, { from: 'list' });
  }
  // A #part-N typed or tapped while already on the page loads nothing, so
  // the load-time check never saw it (2026-10-17, #part-29 on the Nautilus
  // CC Plus did nothing). Our own pushState/replaceState fire no hashchange;
  // a part already open is left alone.
  window.addEventListener('hashchange', function () {
    var m = HASH.exec(location.hash);
    if (!m || normLegend(decodeURIComponent(m[1])) === drawerLegend) return;
    if (skuMapReady) openFromHash();
  });

  if (drawer) drawer.querySelector('.ezp-schem__drawer-close').addEventListener('click', function (e) { e.stopPropagation(); dismissDrawer(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawerLegend) dismissDrawer(); });

  /* ── phones: a bottom sheet (2026-10-06) ──────────────────────────────
     Below 768px the drawer is a sheet with two resting heights: 60% of the
     screen ("peek": the drawing and the tapped number stay in view above it)
     and 92% ("full"). It is ALWAYS 92% tall; peek just sits lower, moved by
     a transform, so a drag only moves it (no layout per frame) and follows
     the finger 1:1, like an iOS sheet.

     A drag can start ANYWHERE on the sheet, the way Apple Maps behaves:
       - swiping down while the parts list is at its top moves the sheet;
       - swiping up while it is at peek grows it to full before anything
         scrolls;
       - otherwise the list scrolls as normal.
     A swipe inside the sheet never scrolls the page behind it: when the list
     cannot scroll that way the move is cancelled. That fall-through is what
     made the page move instead of the sheet.

     Letting go settles by SPEED first (a flick goes one step that way), then
     by position. Touch events, not pointer events: whether to scroll or to
     drag is decided after the finger has started moving, and only a
     non-passive touchmove can still cancel the scroll at that point. A tap
     on the handle toggles the two heights. The resting positions are CSS. */
  var sheetQuery = window.matchMedia('(max-width: 767px)');
  var keepCalloutVisible = null;

  /* How much of the top of the screen the store pins over the page (the
     PoolFix bar + the sticky header: 245 of 812px on an iPhone, 2026-10-16).
     Measured, never assumed — the header is OuterBox's and can change. Walks
     down from the top edge, stacking whatever fixed / sticky element is there. */
  function pinnedTop() {
    if (isFocus()) return Math.max(0, stage.getBoundingClientRect().top);
    var y = 0;
    for (var n = 0; n < 4; n++) {
      var el = document.elementFromPoint(window.innerWidth / 2, y + 1);
      var pinned = null;
      for (var p = el; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
        if (root.contains(p)) break;
        var pos = getComputedStyle(p).position;
        if (pos === 'fixed' || pos === 'sticky') pinned = p;
      }
      if (!pinned) break;
      var b = pinned.getBoundingClientRect().bottom;
      if (!(b > y + 1) || b > window.innerHeight * 0.6) break;
      y = b;
    }
    return y;
  }

  /* The sheet's "peek" height on a phone (2026-10-16). It used to be a fixed
     60%, which with the pinned header left ~80px of drawing between them — the
     tapped number could not be shown however the page scrolled (Nate). Now the
     sheet leaves at least DRAWING_MIN px of drawing under the pinned header,
     and never covers less than 38% or more than 60% of the screen. */
  var DRAWING_MIN = 250;
  var peekShown = 0;   // px of sheet showing at peek, for keepCalloutVisible
  function sizePeek() {
    if (!drawer || !sheetQuery.matches) return;
    var vh = window.innerHeight;
    peekShown = Math.round(Math.min(vh * 0.6, Math.max(vh * 0.38, vh - pinnedTop() - DRAWING_MIN)));
    drawer.style.setProperty('--ezp-peek', Math.max(0, drawer.offsetHeight - peekShown) + 'px');
  }

  if (drawer) {
    var grab = document.createElement('div');
    grab.className = 'ezp-schem__grab';
    grab.setAttribute('aria-hidden', 'true');
    drawer.insertBefore(grab, drawer.firstChild);
    grab.addEventListener('click', function (e) { e.stopPropagation(); if (sheetQuery.matches) drawer.classList.toggle('is-full'); });

    var sheetBody = drawer.querySelector('.ezp-schem__drawer-body');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var gest = null;   // {x0, y0, base, h, mode: null|'drag'|'scroll'|'none', samples:[{y,t}]}

    // where the sheet rests at peek, as a translateY in px
    var peekY = function () { return Math.max(0, drawer.offsetHeight - (peekShown || window.innerHeight * 0.6)); };
    var currentY = function () {
      var tf = getComputedStyle(drawer).transform;
      if (!tf || tf === 'none') return 0;
      var m = tf.match(/matrix(3d)?\(([^)]+)\)/);
      if (!m) return 0;
      var n = m[2].split(',').map(parseFloat);
      return m[1] ? n[13] : n[5];
    };

    drawer.addEventListener('touchstart', function (e) {
      if (!sheetQuery.matches || !drawerLegend || e.touches.length !== 1) { gest = null; return; }
      var t = e.touches[0];
      gest = {
        x0: t.clientX, y0: t.clientY, base: currentY(), h: drawer.offsetHeight, mode: null,
        onHead: !!(e.target.closest && (e.target.closest('.ezp-schem__grab') || e.target.closest('.ezp-schem__drawer-top'))),
        samples: [{ y: t.clientY, t: e.timeStamp }],
      };
    }, { passive: true });

    drawer.addEventListener('touchmove', function (e) {
      if (!gest || e.touches.length !== 1) return;
      var t = e.touches[0];
      var dx = t.clientX - gest.x0, dy = t.clientY - gest.y0;
      if (!gest.mode) {
        if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
        var full = drawer.classList.contains('is-full');
        var atTop = sheetBody.scrollTop <= 0;
        var canScrollDown = sheetBody.scrollTop + sheetBody.clientHeight < sheetBody.scrollHeight - 1;
        if (Math.abs(dx) > Math.abs(dy)) gest.mode = 'scroll';                              // sideways: leave it
        else if (gest.onHead || (dy > 0 && atTop) || (dy < 0 && !full)) gest.mode = 'drag';
        else gest.mode = (dy < 0 ? canScrollDown : !atTop) ? 'scroll' : 'none';
        if (gest.mode === 'drag') drawer.classList.add('is-dragging');
      }
      if (gest.mode === 'none') { e.preventDefault(); return; }   // nothing to scroll: never the page behind
      if (gest.mode !== 'drag') return;
      e.preventDefault();
      var y = gest.base + dy;
      if (y < 0) y = -Math.pow(-y, 0.7);            // a little give past full, like iOS
      drawer.style.transform = 'translate3d(0,' + y + 'px,0)';
      gest.samples.push({ y: t.clientY, t: e.timeStamp });
      if (gest.samples.length > 6) gest.samples.shift();
    }, { passive: false });

    var endGesture = function () {
      var g = gest; gest = null;
      if (!g || g.mode !== 'drag') return;
      var y = currentY();
      drawer.classList.remove('is-dragging');
      drawer.style.transform = '';
      // speed over the last few samples, px per ms (+ = downward)
      var a = g.samples[0], b = g.samples[g.samples.length - 1];
      var v = b.t > a.t ? (b.y - a.y) / (b.t - a.t) : 0;
      var peek = peekY(), closeAt = peek + (g.h - peek) * 0.35;
      var wasFull = g.base < peek / 2;
      var to;
      if (v > 0.45) to = wasFull && y < peek ? 'peek' : 'close';   // flick down: one step
      else if (v < -0.45) to = 'full';                                // flick up
      else if (y > closeAt) to = 'close';
      else to = y < peek / 2 ? 'full' : 'peek';
      if (to === 'close') { dismissDrawer(); return; }
      drawer.classList.toggle('is-full', to === 'full');
    };
    drawer.addEventListener('touchend', endGesture);
    drawer.addEventListener('touchcancel', endGesture);

    /* #7: the tapped number must not end up BEHIND the sheet (2026-10-06).
       Only after a tap on the drawing, only on a phone, and only when the
       number would be hidden: the page scrolls smoothly just far enough to
       put it in the middle of what stays visible above the sheet. If the
       page cannot scroll that far and the drawing is zoomed in, the drawing
       pans the rest. Never zooms; a LIST tap still never moves the drawing. */
    keepCalloutVisible = function (k, at) {
      if (!sheetQuery.matches) return;
      var list = (circlesByLegend[k] || []).filter(function (c) { return c.sheet === active; });
      if (!list.length) return;
      var pick = list[0], best = Infinity;
      list.forEach(function (c) {   // the occurrence that was tapped: nearest the finger
        var r = c.el.getBoundingClientRect();
        var d = at ? Math.hypot(r.left + r.width / 2 - at.x, r.top + r.height / 2 - at.y) : 0;
        if (d < best) { best = d; pick = c; }
      });
      var rect = pick.el.getBoundingClientRect();
      var cy = rect.top + rect.height / 2;
      // what stays visible: below the store's pinned header, above the sheet
      var visibleTop = pinnedTop();
      var visibleBottom = window.innerHeight - (peekShown || window.innerHeight * 0.6);
      var band = Math.max(40, visibleBottom - visibleTop);
      var margin = Math.min(band / 2 - 1, Math.max(28, rect.height / 2 + 12));
      if (cy >= visibleTop + margin && cy <= visibleBottom - margin) return;   // already in view
      var delta = cy - (visibleTop + band / 2);
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      // in full screen the page behind must not move: the drawing pans it all
      var target = isFocus() ? window.scrollY : Math.max(0, Math.min(maxScroll, window.scrollY + delta));
      var rest = delta - (target - window.scrollY);
      if (Math.abs(target - window.scrollY) > 1) window.scrollTo({ top: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      var sh = sheets[active];
      if (Math.abs(rest) > 4 && sh && sh.view && sh.view.w < sh.box.w - 0.5) {
        var scale = unitsPerPx(sh);
        setView(sh, { x: sh.view.x, y: sh.view.y + rest * scale, w: sh.view.w, h: sh.view.h });
      }
    };
  }

  /* ── FULL SCREEN / focus mode (2026-10-07) ────────────────────────────
     The ⛶ button makes the WHOLE section fill the screen: the drawing
     takes all of it, the parts list is put away, and a number still opens
     its part the usual way — the panel floats over the drawing's top right
     on a desktop, the side drawer / bottom sheet below 1024px (both live
     inside the section, so they show in true full screen too).
     Two layers, because iPhone Safari has no Fullscreen API for a page:
       - the `is-focus` class does the layout everywhere (position: fixed);
       - where the browser allows it (desktops, Android) the section is also
         put in REAL full screen, hiding the browser's own bars.
     Ways out, all the same: "Exit full screen", Esc (closes an open part
     first), the back button (one history entry, like the drawer's), and the
     browser leaving full screen by itself. */
  var focusBtn = stage.querySelector('[data-focus]');
  var exitBtn = root.querySelector('.ezp-schem__focus-exit');
  var focusPushed = false;
  function isFocus() { return root.classList.contains('is-focus'); }
  var fsElement = function () { return document.fullscreenElement || document.webkitFullscreenElement || null; };
  // a phone in full screen keeps the drawing at the TOP of the tall stage:
  // centred, a landscape drawing sat exactly where the part sheet opens
  var phoneQuery = window.matchMedia('(max-width: 767px)');
  function alignSheets() {
    var a = isFocus() && phoneQuery.matches ? 'xMidYMin meet' : 'xMidYMid meet';
    sheets.forEach(function (sh) { if (sh && sh.el) sh.el.setAttribute('preserveAspectRatio', a); });
  }
  function refit(toFit) {
    alignSheets();
    requestAnimationFrame(function () {
      var sh = sheets[active]; if (!sh || !sh.view) return;
      if (toFit) fit(sh); else setView(sh, sh.view);
    });
  }
  function enterFocus() {
    if (isFocus()) return;
    resetPageZoom();
    root.classList.add('is-focus');
    document.documentElement.classList.add('ezp-schem-locked');
    if (focusBtn) focusBtn.setAttribute('aria-pressed', 'true');
    try { history.scrollRestoration = 'manual'; } catch (e) { /* */ }
    // An open part that THIS page pushed sits one entry above the bare
    // diagram, so closing it (history.back) used to land on that diagram entry
    // — which has no focus flag — and left full screen (Nate, 2026-10-16:
    // tap a number, full screen, close the part). So its entry becomes the
    // focus entry and the part is pushed again above it: [diagram, focus,
    // part]. Closing the part now lands on focus; Exit goes back two.
    // A part opened from a link (#part-01) was not pushed, so its entry
    // just gains the flag, as before.
    if (history.state && history.state.ezpPart && pushedHere) {
      var openK = history.state.ezpPart;
      history.replaceState({ ezpFocus: true }, '', partUrl(''));
      history.pushState({ ezpPart: openK, ezpFocus: true }, '', partUrl(openK));
      focusPushed = true;
    } else if (history.state && history.state.ezpPart) {
      history.replaceState({ ezpPart: history.state.ezpPart, ezpFocus: true }, '', location.href);
    } else {
      history.pushState({ ezpFocus: true }, '', location.href);
      focusPushed = true;
    }
    var req = root.requestFullscreen || root.webkitRequestFullscreen;
    if (req) { try { var p = req.call(root); if (p && p.catch) p.catch(function () { /* the class alone does it */ }); } catch (e) { /* */ } }
    refit(true);
    if (exitBtn) exitBtn.focus({ preventScroll: true });
  }
  // fromHistory: we are already on the entry below ours (back was pressed)
  function exitFocus(fromHistory) {
    if (!isFocus()) return;
    if (!fromHistory && focusPushed && history.state && history.state.ezpFocus) {
      // go back over our entries; popstate lands here again with fromHistory
      history.go(history.state.ezpPart && pushedHere ? -2 : -1);
      return;
    }
    root.classList.remove('is-focus');
    document.documentElement.classList.remove('ezp-schem-locked');
    if (focusBtn) focusBtn.setAttribute('aria-pressed', 'false');
    focusPushed = false;
    if (fsElement() === root) {
      var ex = document.exitFullscreen || document.webkitExitFullscreen;
      try { var p = ex && ex.call(document); if (p && p.catch) p.catch(function () {}); } catch (e) { /* */ }
    }
    refit(false);
  }
  if (focusBtn) focusBtn.addEventListener('click', function (e) { e.stopPropagation(); if (isFocus()) exitFocus(); else enterFocus(); });
  if (exitBtn) exitBtn.addEventListener('click', function (e) { e.stopPropagation(); exitFocus(); });
  // the browser left full screen by itself (its own Esc, Android back): follow it
  var onFsChange = function () { if (!fsElement() && isFocus()) exitFocus(); };
  document.addEventListener('fullscreenchange', onFsChange);
  document.addEventListener('webkitfullscreenchange', onFsChange);
  window.addEventListener('popstate', function (e) {
    if (isFocus() && !(e.state && e.state.ezpFocus)) exitFocus(true);
  });
  // Esc: an open part closes first (its own handler), the next Esc leaves.
  // Capture phase, so this sees whether a part was open BEFORE it closes.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isFocus() && !drawerLegend) exitFocus();
  }, true);

  /* ── the PAGE must not zoom by accident (2026-10-16, Nate on an iPhone) ──
     A pinch meant for the drawing that the browser took for the page left
     everything zoomed, the part sheet included. Two guards:
       1. a pinch that starts ON the drawing is the drawing's: iOS Safari
          ignores touch-action for pinch and zooms the page through its own
          gesture events, so those are cancelled here (the drawing still
          zooms through the touch handlers in wireStage);
       2. if the page IS zoomed when a part opens or full screen starts, it is
          put back to 100% first — the sheet and full screen are laid out for
          the screen, not for a magnified piece of it. Done by briefly adding
          maximum-scale=1 to the viewport tag (what iOS and Android both
          snap back on) and restoring the tag a moment later, so the visitor
          can still zoom the page afterwards. */
  ['gesturestart', 'gesturechange'].forEach(function (type) {
    stage.addEventListener(type, function (e) { e.preventDefault(); }, { passive: false });
  });
  var viewportMeta = document.querySelector('meta[name="viewport"]');
  var viewportRestore = null;
  function resetPageZoom() {
    var vv = window.visualViewport;
    if (!vv || vv.scale <= 1.01 || !viewportMeta) return false;
    var orig = viewportRestore ? viewportRestore.content : viewportMeta.getAttribute('content') || 'width=device-width, initial-scale=1';
    clearTimeout(viewportRestore && viewportRestore.timer);
    viewportMeta.setAttribute('content', orig.replace(/,?\s*maximum-scale\s*=\s*[^,]*/i, '') + ', maximum-scale=1');
    viewportRestore = { content: orig, timer: setTimeout(function () {
      viewportMeta.setAttribute('content', orig);
      viewportRestore = null;
    }, 500) };
    return true;
  }
  // once the zoom settles (or the visitor zooms anyway), the sheet re-measures
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () {
    if (drawer && drawer.classList.contains('is-open') && !drawer.classList.contains('is-full')) sizePeek();
  });

  /* ── go ────────────────────────────────────────────────────────────── */
  if (isTouch) root.classList.add('is-touch');
  if (!sheetDefs.length) { stage.innerHTML = '<p class="ezp-schem__error">No drawing on this collection yet.</p>'; }
  sheetDefs.forEach(function (def, i) { buildSheet(i, def, (hot.sheets || [])[i]); });
  fetchAllProducts(DATA.handle, function (list) { products = list; enhanceRows(); });
  window.addEventListener('resize', function () { var sh = sheets[active]; if (sh) setView(sh, sh.view); });
})();
